import { render, staticRenderFns } from "./assignCourse.vue?vue&type=template&id=4bc07755&scoped=true&"
import script from "./assignCourse.vue?vue&type=script&lang=js&"
export * from "./assignCourse.vue?vue&type=script&lang=js&"
import style0 from "./assignCourse.vue?vue&type=style&index=0&id=4bc07755&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc07755",
  null
  
)

export default component.exports